import { Box } from '@mui/material'
import ValueLabel, {
  ValueLabelProps,
} from 'components/Common/ValueLabel/ValueLabel'
import { projectNetSalesPriceSelector } from 'features/BillOfMaterials/store/selectors/projectNetSalesPriceSelector'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store/configureStore'
import { imnooEstimationSummarySelector } from '../store/selectors/imnooEstimationSelectors'
import { ProjectPriceStatus } from './ProjectPriceStatus'

export function ProjectNetSalesPrice(props: {
  showEmptyValue?: boolean
  valueLabelProps?: Partial<ValueLabelProps>
}) {
  const { t } = useTranslation()
  const { unresolved } = useAppSelector(imnooEstimationSummarySelector)
  const value = useAppSelector(projectNetSalesPriceSelector)
  if ((value == null || value === '-') && props.showEmptyValue === false)
    return null

  const price = (
    <ValueLabel
      label={t('project:net-sales-price')}
      emptyString="-"
      {...props.valueLabelProps}
      valueLabelRootStyles={
        unresolved
          ? {
              ...props.valueLabelProps?.valueLabelRootStyles,
              height: 'auto',
              paddingTop: 0,
              paddingBottom: 0,
            }
          : props.valueLabelProps?.valueLabelRootStyles
      }
      value={value}
    />
  )
  if (!unresolved) return price

  return (
    <Box
      sx={{
        display: 'inline-flex',
        flexWrap: 'wrap',
        alignSelf: 'flex-start',
        alignItems: 'flex-start',
        justifyContent: props.valueLabelProps?.isLeftAligned
          ? 'flex-start'
          : 'flex-end',
        columnGap: 0.5,
        paddingY: 0.5,
        minWidth: props.valueLabelProps?.disableMinWidth
          ? 0
          : (theme) => theme.spacing(7),
        '& > [role="status"]': {
          alignSelf: 'flex-end',
        },
      }}
    >
      {price}
      <ProjectPriceStatus />
    </Box>
  )
}
